import script from "./aboutIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./aboutIndex.vue?vue&type=script&setup=true&lang=js"

import "./aboutIndex.vue?vue&type=style&index=0&id=0bc9fa23&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bc9fa23"]])

export default __exports__